import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

const PaymentSearchBar = ({
	payments,
	setMember,
	setSearch,
	setSearchCriteria,
	country,
}) => {
	
	let memberInfo = [];
	for (var i = 0; i < payments?.length; i++) {
		memberInfo.push({
			members: payments[i]?.members
		});
	}


	const handleSearch = (e) => e.preventDefault();

	const handlePfNumber = (e) => {
		if (!e.target.value) return setMember(payments);
		const name = e.target.name;

		let searchData = e.target.value.toUpperCase();

		const resultArray = payments?.filter((payment) =>
			payment?.pf_number?.includes(searchData)
		);
		setSearchCriteria({
			[name]: searchData,
		});
		setSearch(true);
		setMember(resultArray);
	};

	const handleMobileNumber = (value, countryObj, e, formattedValue) => {
		if (!value) return setMember(payments);
		const name = e.target.name;
		let searchData = value.replaceAll(" ", "");

		if (searchData.substring(4, 0) === "2330") {
			searchData = searchData.replace("0", "");
		}
		const resultArray = payments?.filter((payment) =>
			payment?.mobile_number?.includes(searchData)
		);
		setSearchCriteria({
			[name]: searchData,
		});
		setSearch(true);
		setMember(resultArray);
	};

	const handleFirstname = (e) => {
		if (!e.target.value) return setMember(payments);
		const name = e.target.name;
		let searchData = e.target.value.toUpperCase();

		const resultArray = payments?.filter((payment) =>
			payment?.members?.first_name.includes(searchData)
		);
		
		setSearchCriteria({
			[name]: searchData,
		});
		setSearch(true);
		setMember(resultArray);
	};
	const handleLastname = (e) => {
		if (!e.target.value) return setMember(payments);
		const name = e.target.name;
		let searchData = e.target.value.toUpperCase();

		const resultArray = payments?.filter((payment) =>
			payment?.members?.last_name.includes(searchData)
		);
		setSearchCriteria({
			[name]: searchData,
		});
		setSearch(true);
		setMember(resultArray);
	};

	return (
		<>
			<form onSubmit={handleSearch}>
				<div className="form-group row">
					<div
						style={{ fontSize: 16, width: "12%" }}
						className="col-sm-2"
					>
						Search Member
					</div>
					<div className="col-sm-3">
						<input
							className="form-control"
							type="text"
							style={{
								width: "100%",
								height: 40,
								fontSize: 16,
								textTransform: "uppercase",
								borderRadius: 5,
							}}
							placeholder="PF Number"
							name="pf_number"
							onChange={handlePfNumber}
						/>
					</div>
					<div className="col-sm-3">
						<PhoneInput
							inputStyle={{
								fontSize: 16,
								color: "gray",
								width: "100%",
								height: 40,
							}}
							country={country}
							countryCodeEditable={false}
							enableSearch={true}
							name="mobile_number"
							onChange={(value, countryObj, e, formattedValue) =>
								handleMobileNumber(
									value,
									countryObj,
									e,
									formattedValue
								)
							}
						/>
					</div>
					<div className="col-sm-2">
						<input
							className="form-control"
							type="text"
							placeholder="FirstName"
							style={{
								width: "100%",
								height: 40,
								fontSize: 16,
								textTransform: "uppercase",
								borderRadius: 5,
							}}
							name="first_name"
							onChange={handleFirstname}
						/>
					</div>
					<div className="col-sm-2">
						<input
							className="form-control"
							type="text"
							placeholder="LastName"
							style={{
								width: "100%",
								height: 40,
								fontSize: 16,
								textTransform: "uppercase",
								borderRadius: 5,
							}}
							name="last_name"
							onChange={handleLastname}
						/>
					</div>
				</div>
			</form>
		</>
	);
};

export default PaymentSearchBar;
